import classNames from "classnames";
import React from "react";
import "./TableClasses.scss";

const TableDataCell = (props: {
  maxWidth?: number | string;
  minWidth?: number | string;
  className?: string;
  children: any;
  paddingRight?: string | number;
  paddingLeft?: string | number;
}) => {
  const {
    maxWidth = "fit-content",
    minWidth = "fit-content",
    className = "",
    paddingRight = 15,
    paddingLeft = 15,
    children,
  } = props;

  let updatedMaxWidth: any = "fit-content";
  let updatedMinWidth: any = "fit-content";

  if (maxWidth != "fit-content") {
    updatedMaxWidth = maxWidth as number;
    updatedMaxWidth = (updatedMaxWidth as any) + paddingRight + paddingLeft;
  }
  if (minWidth != "fit-content") {
    updatedMinWidth = minWidth as number;
    updatedMinWidth = (updatedMinWidth as any) + paddingRight + paddingLeft;
  }

  return (
    <th
      className={classNames("table-data-cell", className)}
      style={{
        minWidth: updatedMinWidth,
        maxWidth: updatedMaxWidth,
        paddingRight: paddingRight,
        paddingLeft: paddingLeft,
      }}
    >
      {children}
    </th>
  );
};

export default TableDataCell;
